// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import axios from "axios"
import React, { useEffect, useState } from "react"
import { useLocales } from "react-localized"
import ReactMarkdown from 'react-markdown'
import { IonText } from "@ionic/react"
import SectionLoading from "./SectionLoading"
import './DocumentationComponent.scss'


const http = axios.create({
  baseURL: "/assets/docs",
  validateStatus: (status) => [200, 404].includes(status)
})


interface DocumentationComponentProps {
  name: string
  style?: React.CSSProperties
}


const DocumentationComponent: React.FC<DocumentationComponentProps> = ({
  name,
  style
}) => {
  const {locale} = useLocales()
  const defaultLanguage: string = "en"
  const path = `/${locale}/${name}.md`
  const [content, setContent] = useState<string|null>(null)

  const retrieveDocument: (path: string) => Promise<string> = async (path) => {
    let doc: string = `The document ${path} does not exist.`
    let response = await http.get(path)
    if (response.status === 404 && locale !== defaultLanguage) {
      response = await http.get(`/${defaultLanguage}/${name}.md`)
    }
    if (response.status === 200) {
      doc = response.data
    }
    return doc
  }

  useEffect(() => {
    if (content === null) {
      retrieveDocument(path).then(setContent)
    }
  }, [content])

  if (content === null) {
    return (<SectionLoading fullheight/>)
  }
  return (
    <IonText className="docs docs-markdown">
      {(!content) ? (<SectionLoading/>) : (<ReactMarkdown>{content}</ReactMarkdown>)}
      
    </IonText>
  )
}

export { DocumentationComponent }